import { Feature, MultiPolygon, Polygon } from '@turf/turf';
import { FieldBoundarySuggestionSource } from 'app/utils/field-boundary-suggestion.utils';

export const CREATE_FIELD_ROUTE = '/my-fields/criar-talhao';

/**
 * What a screen hands over to the field creation screen (`CREATE_FIELD_ROUTE`).
 *
 * @remarks
 * Always sent as router navigation state, never as query params. Field
 * geometry, map centers and field names are location data about the user's
 * property, and URLs leak: they stay in the browser history, and tools the
 * app does not control (GA4 history-based page views, GTM tags) can read the
 * full URL, even though the app itself only reports route paths to Google
 * Analytics.
 */
export interface CreateFieldNavigationState {
  /** Boundary to prefill: suggested from a task or imported from a shapefile. */
  feature?: Feature<Polygon | MultiPolygon>;
  /** Set when `feature` was suggested from a task. */
  boundarySource?: FieldBoundarySuggestionSource;
  /** Where to center the map when there is no boundary to prefill. */
  center?: { lat: number; lng: number };
  /** The task's field name, which is how the task later finds its field. */
  fieldName?: string;
}
